import axios from 'axios';

const API_BASE_URL = 'https://vitaldev.vitalinsights.in';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('token')}`
  }
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const healthGoalsService = {
  getAllGoals: async () => {
    try {
      const response = await api.get('/health/health-goals');
      return response.data.data || [];
    } catch (error) {
      console.error('Error fetching health goals:', error);
      throw error;
    }
  },

  createGoal: async (goalData) => {
    try {
      const response = await api.post('/health/health-goals', goalData);
      return response.data;
    } catch (error) {
      console.error('Error creating goal:', error);
      throw error;
    }
  },

  updateGoal: async (goalId, goalData) => {
    try {
      const response = await api.put(`/health/health-goals/${goalId}`, goalData);
      return response.data;
    } catch (error) {
      console.error('Error updating goal:', error);
      throw error;
    }
  },

  deleteGoal: async (goalId) => {
    try {
      const response = await api.put(`/health/health-goals/${goalId}`, { is_active: false });
      return response.data;
    } catch (error) {
      console.error('Error deleting goal:', error);
      throw error;
    }
  }
};
